import { render, staticRenderFns } from "./EditUpdates.vue?vue&type=template&id=26ec333e"
import script from "./EditUpdates.vue?vue&type=script&lang=js"
export * from "./EditUpdates.vue?vue&type=script&lang=js"
import style0 from "./EditUpdates.vue?vue&type=style&index=0&id=26ec333e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports